import { render, staticRenderFns } from "./TrackingPayPalTableAdmin.vue?vue&type=template&id=3b2844fc&scoped=true"
import script from "./TrackingPayPalTableAdmin.vue?vue&type=script&lang=js"
export * from "./TrackingPayPalTableAdmin.vue?vue&type=script&lang=js"
import style0 from "./TrackingPayPalTableAdmin.vue?vue&type=style&index=0&id=3b2844fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2844fc",
  null
  
)

export default component.exports